import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutionsSection() {
  const failures = [{
    title: 'Duchas frías',
    description: 'Solo alivian por unos minutos, y después el sofoco vuelve con más fuerza.'
  }, {
    title: 'Suplementos caros',
    description: 'Prometen mucho en la etiqueta, pero no atacan la raíz hormonal del problema.'
  }, {
    title: 'Yoga o meditación',
    description: 'Ayudan con el estrés general, pero no enfrían tu cuerpo en el momento crítico de la noche.'
  }, {
    title: 'Hormonas sintéticas',
    description: 'Te dan miedo por los posibles efectos secundarios a largo plazo y prefieres evitarlas.'
  }];
  return <section className="py-20 bg-slate-900 text-white" data-id="element-18">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-21">
            Por qué lo que has intentado no ha funcionado
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-22">
            No es tu culpa. La mayoría de las soluciones tratan el síntoma, no
            la causa raíz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-23">
          {failures.map((item, index) => <div key={index} className="bg-slate-800 p-8 rounded-2xl border border-slate-700 hover:border-slate-600 transition-colors" data-id="element-24">
              <div className="flex items-start" data-id="element-25">
                <XCircle className="w-8 h-8 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-26" />
                <div data-id="element-27">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-28">
                    {item.title}
                  </h3>
                  <p className="text-slate-300 leading-relaxed" data-id="element-29">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}